<!--<small class="debug">{{me}}</small>-->
<div [ngClass]="enterpriseMode ? 'globalStyle' : ''">
    <div class="overview-log-table">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
            <ng-container matColumnDef="date">
                <th mat-header-cell *matHeaderCellDef> {{'general.date' | transloco}}</th>
                <td mat-cell *matCellDef="let element"> {{element.date}} </td>
            </ng-container>
            <ng-container matColumnDef="message">
                <th mat-header-cell *matHeaderCellDef> {{'general.message' | transloco}}</th>
                <td mat-cell *matCellDef="let element"> {{element.message}} </td>
            </ng-container>
            <ng-container matColumnDef="severity">
                <th mat-header-cell *matHeaderCellDef> {{'general.severity' | transloco}}</th>
                <td mat-cell *matCellDef="let element"> {{element.severity}} </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
</div>
